import { render, staticRenderFns } from "./ViewSelaaToolbarBtn.vue?vue&type=template&id=373437d4&"
import script from "./ViewSelaaToolbarBtn.vue?vue&type=script&lang=js&"
export * from "./ViewSelaaToolbarBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373437d4')) {
      api.createRecord('373437d4', component.options)
    } else {
      api.reload('373437d4', component.options)
    }
    module.hot.accept("./ViewSelaaToolbarBtn.vue?vue&type=template&id=373437d4&", function () {
      api.rerender('373437d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ViewSelaaToolbarBtn.vue"
export default component.exports